import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { getLocale } from "~/i18n";
import invariant from "tiny-invariant";

interface Props {
  lastUpdated?: Date;
}

const Author: React.FC<Props> = (
  {
    lastUpdated = null
  }
) => {
  const { t } = useTranslation("translations");

  const locale = getLocale(useLocation().pathname);
  invariant(locale, "Locale is not defined");

  return (
    <div className="flex flex-row gap-10 items-center my-6">
      <div
        className="flex flex-row gap-4 items-center transition-all duration-300 ease-in-out hover:scale-105 hover:text-blue-400">
        <img className="rounded-circle h-[60px]" src="https://static.countlike.pro/Alex-Fedorov.webp"
             alt="Alex Fedorov" />
        <div>
          {t("created_by")} <strong>{ locale === 'ru' ? 'Александром Федоровым' : 'Alex Fedorov'}</strong>
          {lastUpdated === null ? null : <>
            <br />
            <small>{t("last_updated")} : {lastUpdated.toLocaleDateString(locale, {
              year: "numeric",
              month: "long",
              day: "numeric"
            })}</small>
          </>}
        </div>
      </div>
    </div>
  );
};

export default Author;